import Image from 'next/image';
import Marquee from 'react-fast-marquee';

import { ourClientsCompaniesList } from '@/assets/clients/our-clients-companies/ourClientsCompaniesList';

import Text from '../Text';

const OurClientsMarquee = () => {
  return (
    <div
      className="flex w-full max-w-7xl flex-col items-center justify-center gap-10"
      style={{
        WebkitMaskImage:
          'linear-gradient(to right, transparent, black 20%, black 80%, transparent)',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskSize: '100% 100%',
        maskImage:
          'linear-gradient(to right, transparent, black 20%, black 80%, transparent)',
        maskRepeat: 'no-repeat',
        maskSize: '100% 100%',
      }}
    >
      <Text className="text-neutral-0">
        Trusted by 250+ businesses worldwide
      </Text>
      <Marquee autoFill className="overflow-hidden">
        {Object.entries(ourClientsCompaniesList).map(([key, Img]) => (
          <div key={key} className="px-9">
            <Image src={Img} alt="" className="h-16 w-auto grayscale" />
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default OurClientsMarquee;
